export const BROKERS = [
  '99Pay',
  'Ágora Investimentos',
  'Ágora Investimentos Empresas',
  'Avenue',
  'Banco Bmg',
  'Banco Bmg Empresas',
  'Banco BRB',
  'Banco BRB Empresas',
  'Banco Digio',
  'Banco do Brasil',
  'Banco do Brasil Empresas',
  'Banco do Brasil Previdência',
  'Banco do Nordeste do Brasil',
  'Banco do Nordeste do Brasil Empresas',
  'Banco Master',
  'Banco Mercantil',
  'Banco Mercantil Empresas',
  'Banco PAN',
  'Banco Paulista',
  'Banco Paulista Empresas',
  'Banco Semear',
  'Banco Sofisa',
  'Banco Sofisa Empresas',
  'Banrisul',
  'Banrisul Empresas',
  'Bradescard',
  'Bradesco',
  'Bradesco Empresas',
  'BTGPactual',
  'BTGPactual Empresas',
  'BTGPactual Investimentos',
  'BTGPactual Investimentos Empresas',
  'BTG - Wealth',
  'BV - Corporate',
  'BV - Pessoa Física - APP',
  'BV - Pessoa Física - Web',
  'BV - Private',
  'C6 Bank',
  'C6 Bank Empresas',
  'Caixa Economica Federal ',
  'Caixa Econômica Federal',
  'Caixa Economica Federal Empresas',
  'Caixa Econômica Federal Empresas',
  'Caixa Previdência',
  'Caixa Tem',
  'Clear Corretora',
  'Inter',
  'Inter Empresas',
  'Itaú',
  'Itaú BBA',
  'Itaú Cartões',
  'Itaú Empresas',
  'Nubank',
  'Nubank Empresas',
  'PagBank',
  'PagBank Empresas',
  'PicPay',
  'Rico Investimentos',
  'Safra',
  'Safra Empresas',
  'Santander',
  'Santander Empresas',
  'XP Banking',
  'XP Investimentos',
]

export const MAP_BROKERS = {
  '99Pay': 'https://cdn.pluggy.ai/assets/connector-icons/804.png',
  'Ágora Investimentos': 'https://cdn.pluggy.ai/assets/connector-icons/620.svg',
  'Ágora Investimentos Empresas':
    'https://cdn.pluggy.ai/assets/connector-icons/620.svg',
  Avenue: 'https://cdn.pluggy.ai/assets/connector-icons/230.svg',
  'Banco Bmg': 'https://cdn.pluggy.ai/assets/connector-icons/652.svg',
  'Banco Bmg Empresas': 'https://cdn.pluggy.ai/assets/connector-icons/666.svg',
  'Banco BRB': 'https://cdn.pluggy.ai/assets/connector-icons/682.svg',
  'Banco BRB Empresas': 'https://cdn.pluggy.ai/assets/connector-icons/682.svg',
  'Banco Digio': 'https://cdn.pluggy.ai/assets/connector-icons/653.svg',
  'Banco do Brasil': 'https://cdn.pluggy.ai/assets/connector-icons/211.svg',
  'Banco do Brasil Empresas':
    'https://cdn.pluggy.ai/assets/connector-icons/662.svg',
  'Banco do Brasil Previdência':
    'https://cdn.pluggy.ai/assets/connector-icons/211.svg',
  'Banco do Nordeste do Brasil':
    'https://cdn.pluggy.ai/assets/connector-icons/671.svg',
  'Banco do Nordeste do Brasil Empresas':
    'https://cdn.pluggy.ai/assets/connector-icons/671.svg',
  'Banco Master': 'https://cdn.pluggy.ai/assets/connector-icons/680.svg',
  'Banco Mercantil': 'https://cdn.pluggy.ai/assets/connector-icons/742.svg',
  'Banco Mercantil Empresas':
    'https://cdn.pluggy.ai/assets/connector-icons/742.svg',
  'Banco PAN': 'https://cdn.pluggy.ai/assets/connector-icons/657.svg',
  'Banco Paulista': 'https://cdn.pluggy.ai/assets/connector-icons/705.svg',
  'Banco Paulista Empresas':
    'https://cdn.pluggy.ai/assets/connector-icons/705.svg',
  'Banco Semear': 'https://cdn.pluggy.ai/assets/connector-icons/277.svg',
  'Banco Sofisa': 'https://cdn.pluggy.ai/assets/connector-icons/714.svg',
  'Banco Sofisa Empresas':
    'https://cdn.pluggy.ai/assets/connector-icons/715.svg',
  Banrisul: 'https://cdn.pluggy.ai/assets/connector-icons/659.svg',
  'Banrisul Empresas': 'https://banrisul.com.br/bob/data/Simbolo-Banrisul.svg',
  Bradescard: 'https://cdn.pluggy.ai/assets/connector-icons/603.svg',
  Bradesco: 'https://cdn.pluggy.ai/assets/connector-icons/203.svg',
  'Bradesco Empresas': 'https://cdn.pluggy.ai/assets/connector-icons/209.svg',
  BTGPactual: 'https://cdn.pluggy.ai/assets/connector-icons/214.svg',
  'BTGPactual Empresas': 'https://cdn.pluggy.ai/assets/connector-icons/214.svg',
  'BTGPactual Investimentos':
    'https://cdn.pluggy.ai/assets/connector-icons/214.svg',
  'BTGPactual Investimentos Empresas':
    'https://cdn.pluggy.ai/assets/connector-icons/214.svg',
  'BTG - Wealth': 'https://cdn.pluggy.ai/assets/connector-icons/214.svg',
  'BV - Corporate': 'https://cdn.pluggy.ai/assets/connector-icons/718.svg',
  'BV - Pessoa Física - APP':
    'https://cdn.pluggy.ai/assets/connector-icons/716.svg',
  'BV - Pessoa Física - Web':
    'https://cdn.pluggy.ai/assets/connector-icons/717.svg',
  'BV - Private': 'https://cdn.pluggy.ai/assets/connector-icons/719.svg',
  'C6 Bank': 'https://cdn.pluggy.ai/assets/connector-icons/726.svg',
  'C6 Bank Empresas': 'https://cdn.pluggy.ai/assets/connector-icons/726.svg',
  'Caixa Economica Federal ':
    'https://cdn.pluggy.ai/assets/connector-icons/219.svg',
  'Caixa Econômica Federal':
    'https://cdn.pluggy.ai/assets/connector-icons/219.svg',
  'Caixa Economica Federal Empresas':
    'https://cdn.pluggy.ai/assets/connector-icons/216.svg',
  'Caixa Econômica Federal Empresas':
    'https://cdn.pluggy.ai/assets/connector-icons/616.svg',
  'Caixa Previdência': 'https://cdn.pluggy.ai/assets/connector-icons/219.svg',
  'Caixa Tem': 'https://cdn.pluggy.ai/assets/connector-icons/783.svg',
  'Cartão Atacadão': 'https://cdn.pluggy.ai/assets/connector-icons/821.svg',
  'Cartão Carrefour': 'https://cdn.pluggy.ai/assets/connector-icons/822.svg',
  "Cartão Sam's Club": 'https://cdn.pluggy.ai/assets/connector-icons/820.svg',
  'Citi Empresas': 'https://cdn.pluggy.ai/assets/connector-icons/710.svg',
  'Clear Corretora': 'https://cdn.pluggy.ai/assets/connector-icons/623.svg',
  'Conta Azul': 'https://cdn.pluggy.ai/assets/connector-icons/242.svg',
  'Conta Simples': 'https://cdn.pluggy.ai/assets/connector-icons/283.svg',
  Cora: 'https://cdn.pluggy.ai/assets/connector-icons/250.svg',
  Crefisa: 'https://cdn.pluggy.ai/assets/connector-icons/750.svg',
  'Crefisa Empresas': 'https://cdn.pluggy.ai/assets/connector-icons/750.svg',
  Deel: 'https://cdn.pluggy.ai/assets/connector-icons/235.svg',
  Dock: 'https://cdn.pluggy.ai/assets/connector-icons/810.svg',
  'Efí Bank': 'https://cdn.pluggy.ai/assets/connector-icons/239.svg',
  Empiricus: 'https://cdn.pluggy.ai/assets/connector-icons/233.svg',
  EQI: 'https://cdn.pluggy.ai/assets/connector-icons/271.svg',
  'Ethereum networks': 'https://cdn.pluggy.ai/assets/connector-icons/290.svg',
  InfinitePay: 'https://cdn.pluggy.ai/assets/connector-icons/777.svg',
  'InfinitePay Empresas':
    'https://cdn.pluggy.ai/assets/connector-icons/777.svg',
  Inter: 'https://cdn.pluggy.ai/assets/connector-icons/215.svg',
  'Inter Empresas': 'https://cdn.pluggy.ai/assets/connector-icons/225.svg',
  'Investimentos BB': 'https://cdn.pluggy.ai/assets/connector-icons/673.svg',
  Íon: 'https://cdn.pluggy.ai/assets/connector-icons/677.svg',
  Itaú: 'https://cdn.pluggy.ai/assets/connector-icons/201.svg',
  'Itaú BBA': 'https://cdn.pluggy.ai/assets/connector-icons/218.svg',
  'Itaú Cartões': 'https://cdn.pluggy.ai/assets/connector-icons/247.svg',
  'Itaú Cartões Empresas':
    'https://cdn.pluggy.ai/assets/connector-icons/247.svg',
  'Itaú Empresas': 'https://cdn.pluggy.ai/assets/connector-icons/618.svg',
  'Itaú Emps': 'https://cdn.pluggy.ai/assets/connector-icons/786.svg',
  'Lemon Cash': 'https://cdn.pluggy.ai/assets/connector-icons/292.svg',
  Méliuz: 'https://cdn.pluggy.ai/assets/connector-icons/720.svg',
  'Mercado Bitcoin': 'https://cdn.pluggy.ai/assets/connector-icons/282.svg',
  'Mercado Pago': 'https://cdn.pluggy.ai/assets/connector-icons/206.svg',
  'Mercado Pago Empresas':
    'https://cdn.pluggy.ai/assets/connector-icons/206.svg',
  MeuPluggy: 'https://cdn.pluggy.ai/assets/connector-icons/sandbox.svg',
  Midway: 'https://cdn.pluggy.ai/assets/connector-icons/688.svg',
  'Monte Bravo': 'https://cdn.pluggy.ai/assets/connector-icons/795.svg',
  Necton: 'https://cdn.pluggy.ai/assets/connector-icons/280.svg',
  Neon: 'https://cdn.pluggy.ai/assets/connector-icons/689.svg',
  Next: 'https://cdn.pluggy.ai/assets/connector-icons/656.svg',
  'Next Empresas': 'https://cdn.pluggy.ai/assets/connector-icons/656.svg',
  Nubank: 'https://cdn.pluggy.ai/assets/connector-icons/212.svg',
  'Nubank Empresas': 'https://cdn.pluggy.ai/assets/connector-icons/212.svg',
  Ontop: 'https://cdn.pluggy.ai/assets/connector-icons/245.svg',
  PagBank: 'https://cdn.pluggy.ai/assets/connector-icons/692.svg',
  'PagBank Empresas': 'https://cdn.pluggy.ai/assets/connector-icons/692.svg',
  'Pague Veloz Serasa': 'https://cdn.pluggy.ai/assets/connector-icons/814.svg',
  'Pague Veloz Serasa Empresas':
    'https://cdn.pluggy.ai/assets/connector-icons/815.svg',
  PicPay: 'https://cdn.pluggy.ai/assets/connector-icons/651.svg',
  'PicPay Negócios': 'https://cdn.pluggy.ai/assets/connector-icons/713.svg',
  "Player's Bank": 'https://cdn.pluggy.ai/assets/connector-icons/765.svg',
  'Porto Bank': 'https://cdn.pluggy.ai/assets/connector-icons/800.svg',
  'QI SCD': 'https://cdn.pluggy.ai/assets/connector-icons/694.svg',
  'QI SCD Empresas': 'https://cdn.pluggy.ai/assets/connector-icons/694.svg',
  RecargaPay: 'https://cdn.pluggy.ai/assets/connector-icons/767.svg',
  'RecargaPay Empresas': 'https://cdn.pluggy.ai/assets/connector-icons/768.svg',
  'Rede Celcoin': 'https://cdn.pluggy.ai/assets/connector-icons/696.svg',
  'Rede Celcoin Empresas':
    'https://cdn.pluggy.ai/assets/connector-icons/696.svg',
  'Rico Investimentos': 'https://cdn.pluggy.ai/assets/connector-icons/205.svg',
  Safra: 'https://cdn.pluggy.ai/assets/connector-icons/229.svg',
  'Safra Empresas': 'https://cdn.pluggy.ai/assets/connector-icons/697.svg',
  'Safra Financeira': 'https://cdn.pluggy.ai/assets/connector-icons/711.svg',
  'Safra Financeira Empresas':
    'https://cdn.pluggy.ai/assets/connector-icons/712.svg',
  SafraPay: 'https://cdn.pluggy.ai/assets/connector-icons/708.svg',
  'SafraPay Empresas': 'https://cdn.pluggy.ai/assets/connector-icons/709.svg',
  Santander: 'https://cdn.pluggy.ai/assets/connector-icons/208.svg',
  'Santander Cartões': 'https://cdn.pluggy.ai/assets/connector-icons/208.svg',
  'Santander Cartões Empresas':
    'https://cdn.pluggy.ai/assets/connector-icons/208.svg',
  'Santander Corretora': 'https://cdn.pluggy.ai/assets/connector-icons/812.svg',
  'Santander Corretora Empresas':
    'https://cdn.pluggy.ai/assets/connector-icons/813.svg',
  'Santander Empresas': 'https://cdn.pluggy.ai/assets/connector-icons/221.svg',
  Sicoob: 'https://cdn.pluggy.ai/assets/connector-icons/228.svg',
  'Sicoob API': 'https://cdn.pluggy.ai/assets/connector-icons/228.svg',
  'Sicoob Empresas': 'https://cdn.pluggy.ai/assets/connector-icons/228.svg',
  Sicredi: 'https://cdn.pluggy.ai/assets/connector-icons/661.svg',
  'Sicredi Empresas': 'https://cdn.pluggy.ai/assets/connector-icons/627.svg',
  Splitwise: 'https://cdn.pluggy.ai/assets/connector-icons/240.svg',
  'Stone Pagamentos': 'https://cdn.pluggy.ai/assets/connector-icons/787.svg',
  'Stone Pagamentos Empresas':
    'https://cdn.pluggy.ai/assets/connector-icons/787.svg',
  'Toro Investimentos': 'https://cdn.pluggy.ai/assets/connector-icons/796.svg',
  'Toro Investimentos Empresas':
    'https://cdn.pluggy.ai/assets/connector-icons/796.svg',
  'Uber Conta by Digio': 'https://cdn.pluggy.ai/assets/connector-icons/674.svg',
  Unicred: 'https://cdn.pluggy.ai/assets/connector-icons/663.svg',
  'Unicred Empresas': 'https://cdn.pluggy.ai/assets/connector-icons/670.svg',
  Wise: 'https://cdn.pluggy.ai/assets/connector-icons/291.svg',
  Woop: 'https://cdn.pluggy.ai/assets/connector-icons/676.svg',
  'XP Banking': 'https://cdn.pluggy.ai/assets/connector-icons/202.svg',
  'XP Banking Empresas': 'https://cdn.pluggy.ai/assets/connector-icons/702.svg',
  'XP Investimentos': 'https://cdn.pluggy.ai/assets/connector-icons/202.svg',
  'XP - Wealth': 'https://cdn.pluggy.ai/assets/connector-icons/248.svg',
}
